var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgUplayGameIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M13.247 0a2.408 2.408 0 0 1 2.408 2.408v10.84a2.408 2.408 0 0 1-2.408 2.407H2.408A2.408 2.408 0 0 1 0 13.247V2.408A2.408 2.408 0 0 1 2.408 0h10.84ZM9.52 2.468c-3.33 0-6.04 2.966-6.04 6.608 0 3.224 4.023 5.193 6.208 5.193 2.288 0 4.847-2.692 4.847-6.3 0-3.488-3.805-5.5-5.015-5.5Zm-2.228 3.75v3.086c0 .222.18.402.404.402h2.414c.223 0 .403-.18.403-.402V6.217h1.343v4.832h-4.16A1.75 1.75 0 0 1 5.95 9.304V6.217h1.342ZM3.155 1.654c-1.163 0-2.035.952-2.035 2.213 0 1.148 1.18 1.678 1.975 1.678.825 0 2.047-.555 2.047-2.105 0-1.41-1.3-1.786-1.987-1.786Zm3.198-.537a.94.94 0 1 0 0 1.88.94.94 0 0 0 0-1.88Z",
  id: "UplayGameIcon_svg__a"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#3B3B3B",
  xlinkHref: "#UplayGameIcon_svg__a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#757575",
  xlinkHref: "#UplayGameIcon_svg__a"
}))));

export default SvgUplayGameIcon;